import * as auth from 'auth'

import './MyAccountBlock.scss'

const Vehicle = ({ make, model, tag }) => <p className="vehicle">{`${make} ${model} - ${tag}`}</p>

const CreditCard = ({ nickName, cardLast4 }) => <p className="credit-card">{`${nickName} ${cardLast4}`}</p>

const MyAccountBlock = user => {
    const { background, name, email, details: { phone } = {}, vehicles = [], creditCards = [] } = user

    return (
        <div className="my-account">
            <Image className="img-container" image={background} background />
            <div className="info-container">
                <h2>
                    <T>dashboard.label.my.account</T>
                </h2>
                <hr />
                <Link to="dashboard/account">
                    <h3 className="user">
                        <T>dashboard.label.information</T>
                    </h3>
                </Link>
                <p className="name">{name}</p>
                <p className="email">{email}</p>
                <p className="phone">{phone}</p>
                <hr />
                <Link to="dashboard/vehicles">
                    <h3 className="vehicles">
                        <T>dashboard.label.vehicles</T>
                    </h3>
                </Link>
                {vehicles.map(vehicle => (
                    <Vehicle {...vehicle} key={vehicle.id} />
                ))}
                <hr />
                <Link to="dashboard/credit-cards">
                    <h3 className="cards">
                        <T>dashboard.label.cards</T>
                    </h3>
                </Link>
                {creditCards.map(card => (
                    <CreditCard {...card} key={card.id} />
                ))}
            </div>
        </div>
    )
}

export default connect(auth.selectors.userSelector)(MyAccountBlock)
